import { getRidersSessionIdFromCookie, setCookie } from "./cookies";
import { isPublicProject } from "./publicProjects";
import { isLocal } from "@/utils";

export const handleRidersLogin = async () => {
	const urlParams = new URLSearchParams(window.location.search);
	const isLti = urlParams.has("isLTI");
	if (import.meta.env.MODE === "stembox" || isPublicProject() || isLocal || isLti) {
		return;
	}

	// If there is no riders session id in the cookie, redirect to the login page
	const ridersSessionId = getRidersSessionIdFromCookie();
	if (!ridersSessionId) {
		setCookie(
			"force-public-next",
			window.location.href,
			{ domain: ".riders.ai" }
		);
		const redirectUrl = `https://${import.meta.env.VITE_LOGIN_DOMAIN}/auth/login?force_redirect=true`;
		console.log("Redirecting to login page", redirectUrl);
		window.location.href = redirectUrl;
	}
}